<template>
    <el-card v-loading="!is_ok" class="page_card" ref="card">
        <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <el-form-item label="姓名">
                <el-input placeholder="请输入姓名" v-model="selectForm.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
                <el-input placeholder="请输入手机号" v-model="selectForm.mobile"></el-input>
            </el-form-item>
            <el-form-item label="职务">
                <el-select v-model="selectForm.jobName" placeholder="请选择">
                    <el-option
                            v-for="item in job_list"
                            :key="item.displayName"
                            :label="item.displayName"
                            :value="item.displayName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="selectForm.status" placeholder="请选择">
                    <el-option
                            v-for="item in status_list"
                            :key="item.id"
                            :label="item.display_name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" plain @click="select()" :loading="is_post"><i class="el-icon-search" /> 查询</el-button>
            <el-button plain @click="refresh()" :loading="is_post"><i class="el-icon-refresh" /> 重置</el-button>
            <el-button type="success" plain @click="addUser()">+ 新增用户</el-button>
        </el-form>
        <el-table :data="data" v-loading="is_loading" :row-class-name="tableClass" stripe :max-height="tableMaxHeight" v-if="showtable">
            <el-table-column label="头像" width="60">
                <template slot-scope="scope">
                    <div class="block">
                        <el-avatar :size="40" :src="scope.row.avatar"></el-avatar>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="登录名">
                <template slot-scope="scope">
                    {{scope.row.username}}
                </template>
            </el-table-column>
            <el-table-column label="姓名">
                <template slot-scope="scope">
                    <div>{{scope.row.name}}</div>
                    <div> <el-link size="mini" type="primary" :underline="false">{{scope.row.jobName}}</el-link> </div>
                </template>
            </el-table-column>
            <el-table-column label="手机号">
                <template slot-scope="scope">
                    {{scope.row.mobile}}
                </template>
            </el-table-column>
            <el-table-column label="邮箱">
                <template slot-scope="scope">
                    {{scope.row.email}}
                </template>
            </el-table-column>
            <el-table-column label="用户组">
                <template slot-scope="scope">
                    <el-tag type="primary" v-for="item of scope.row.roles" style="margin-right: 5px;margin-bottom: 5px">{{item.displayName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-link type="success" :underline="false" :disabled="is_post" v-if="scope.row.status == 1">正常</el-link>
                    <el-link type="warning" :underline="false" :disabled="is_post" v-else >限制登录</el-link>
                </template>
            </el-table-column>
            <el-table-column label="上次登录" width="200">
                <template slot-scope="scope">
                    <div v-if="!scope.row.lastIp">
                        <el-link type="primary" :underline="false">尚未登录</el-link>
                    </div>
                    <div v-else>
                        <el-link type="primary" :underline="false">IP:{{scope.row.lastIp}}</el-link>
                        <br>
                        <el-link type="primary" :underline="false">{{parseTime(scope.row.lastLogin)}}</el-link>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-dropdown trigger="click" placement="bottom-start" @command="clickDrop($event,scope.row)">
                        <el-button type="primary" size="mini" plain>
                            <svg-icon icon-class="many" />
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item class="primary_text" command="resetPwd"> <svg-icon icon-class="password" /> 重置密码</el-dropdown-item>
                            <el-dropdown-item class="warning_text" command="edit"> <svg-icon icon-class="change" /> 编辑</el-dropdown-item>
                            <el-dropdown-item class="danger_text" command="del"> <svg-icon icon-class="del" /> 删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>
        <el-dialog
                title="添加用户"
                :visible.sync="addDialog"
                width="30%"
                center
                top="10vh"
        >
            <el-form label-position="right" ref="addForm" :rules="rules" label-width="80px" :model="addForm" style="padding: 0 20px;">
                <el-form-item label="头像:" prop="avatar">
                    <div>
                        <el-avatar v-if="!add_avatar_review || add_avatar_review.length == 0" :size="50" icon="el-icon-user-solid"></el-avatar>
                        <el-avatar v-else :size="50" :src="add_avatar_review" fit="contain"></el-avatar>
                    </div>
                    <input type="file" name="file" style="display:none;" ref="upload_file1" @change="file_change($event,'add')">
                    <el-tooltip class="item" popper-class="upload_topic" effect="light" content="只能上传png,jpeg,jpg,gif格式的图片,最大1MB!" placement="right">
                        <el-button type="primary" size="mini" plain @click="selectImg('upload_file1')" :loading="is_upload" :disabled="is_post">{{is_upload?'上传中...':'选择图片'}}</el-button>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="登录名:" prop="username">
                    <el-input v-model="addForm.username" :maxlength="20" show-word-limit placeholder="请填写登录名"></el-input>
                </el-form-item>
                <el-form-item label="密码:" prop="password">
                    <el-input v-model="addForm.password" :maxlength="20" show-word-limit type="text" placeholder="请填写密码">
                        <el-button slot="append" @click="random_pwd()">随机生成</el-button>
                    </el-input>
                    <ul class="passwordStrength">
                        <li v-show='pwWeak&&addForm.password!==""&&addForm.password.length>6'><span>弱</span><span></span></li>
                        <li v-show='pwThe&&addForm.password!==""&&addForm.password.length>6'><span>中</span><span></span></li>
                        <li v-show='pwStrong&&addForm.password!==""&&addForm.password.length>6'><span>强</span><span></span></li>
                    </ul>
                </el-form-item>
                <el-form-item label="姓名:" prop="name">
                    <el-input v-model="addForm.name" :maxlength="10" show-word-limit placeholder="请填写姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="mobile">
                    <el-input v-model="addForm.mobile" :maxlength="11" show-word-limit placeholder="请填写手机号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱:" prop="email">
                    <el-input v-model="addForm.email" :maxlength="30" show-word-limit placeholder="请填写邮箱账号"></el-input>
                </el-form-item>
                <el-form-item label="职务:" prop="jobName">
                    <el-input v-model="addForm.jobName" :maxlength="10" show-word-limit placeholder="请填写职务名称"></el-input>
                </el-form-item>
                <el-form-item label="立即启用:">
                    <el-switch
                            v-model="addForm.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="启用"
                            inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="身份组:" prop="roleIds">
                    <el-select v-model="addForm.roleIds" multiple placeholder="请选择" style="width: 100%">
                        <el-option
                            v-for="item in role_list"
                            :key="item.id"
                            :label="item.displayName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" :loading="is_post" plain @click="addSubmit()">提 交</el-button>
                    <el-button plain @click="resetForm()" :loading="is_post">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog
            title="修改用户"
            :visible.sync="editDialog"
            width="30%"
            center
            top="10vh"
        >
            <el-form label-position="right" ref="editForm" :rules="rules" label-width="80px" :model="editForm" style="padding: 0 20px;">
                <el-form-item label="头像:" prop="avatar">
                    <div>
                        <el-avatar v-if="!edit_avatar_review || edit_avatar_review.length == 0" :size="50" icon="el-icon-user-solid"></el-avatar>
                        <el-avatar v-else :size="50" :src="edit_avatar_review" fit="contain"></el-avatar>
                    </div>
                    <input type="file" name="file" style="display:none;" ref="upload_file2" @change="file_change($event,'edit')">
                    <el-tooltip class="item" popper-class="upload_topic" effect="light" content="只能上传png,jpeg,jpg,gif格式的图片,最大1MB!" placement="right">
                        <el-button type="primary" size="mini" plain @click="selectImg('upload_file2')" :loading="is_upload" :disabled="is_post">{{is_upload?'上传中...':'选择图片'}}</el-button>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="登录名:" prop="username">
                    <el-input v-model="editForm.username" :maxlength="20" show-word-limit placeholder="请填写登录名"></el-input>
                </el-form-item>
                <el-form-item label="姓名:" prop="name">
                    <el-input v-model="editForm.name" :maxlength="10" show-word-limit placeholder="请填写姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号:" prop="mobile">
                    <el-input v-model="editForm.mobile" :maxlength="11" show-word-limit placeholder="请填写手机号"></el-input>
                </el-form-item>
                <el-form-item label="邮箱:" prop="email">
                    <el-input v-model="editForm.email" :maxlength="30" show-word-limit placeholder="请填写邮箱账号"></el-input>
                </el-form-item>
                <el-form-item label="职务:" prop="jobName">
                    <el-input v-model="editForm.jobName" :maxlength="10" show-word-limit placeholder="请填写职务名称"></el-input>
                </el-form-item>
                <el-form-item label="立即启用:">
                    <el-switch
                        v-model="editForm.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="启用"
                        inactive-text="禁用">
                    </el-switch>
                </el-form-item>
                <el-form-item label="身份组:" prop="roleIds">
                    <el-select v-model="editForm.roleIds" multiple placeholder="请选择" style="width: 100%">
                        <el-option
                            v-for="item in role_list"
                            :key="item.id"
                            :label="item.displayName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="warning" :loading="is_post" plain @click="editSubmit()">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog  title="重置密码"
                    :visible.sync="editPwdDialog"
                    width="30%"
                    center
                    top="10vh">
            <el-form label-position="right" ref="editPwdForm" :rules="editPwdRules" label-width="80px" :model="editPwdForm" style="padding: 0 20px;">
                <el-form-item label="姓名" v-if="active_user">
                    <el-input v-model="active_user.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input placeholder="请填写重置密码" show-word-limit v-model="editPwdForm.password"></el-input>
                    <ul class="passwordStrength">
                        <li v-show='pwWeak&&editPwdForm.password!==""&&editPwdForm.password.length>6'><span>弱</span><span></span></li>
                        <li v-show='pwThe&&editPwdForm.password!==""&&editPwdForm.password.length>6'><span>中</span><span></span></li>
                        <li v-show='pwStrong&&editPwdForm.password!==""&&editPwdForm.password.length>6'><span>强</span><span></span></li>
                    </ul>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" plain :loading="is_post" @click="editPwdSubmit()">提 交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </el-card>
</template>

<script>
    import request from "@/utils/request"
    import {parseTime,createUniqueString,formatTime} from "@/utils/index"
    import {validEmail,stringTrim,PASSOWRD_REG_WEEK,PASSOWRD_REG_MIDDLE,PASSOWRD_REG_POWER} from "@/utils/elvalid"
    let OSS = require('ali-oss');
    export default {
        name: "auth_userlist",
        data(){
            const passwordStrength=(rule, value, callback)=>{
                if(value.trim().length){
                    if(PASSOWRD_REG_WEEK.test(value)){
                        callback();
                        this.pwWeak=true
                        this.pwThe =false
                        this.pwStrong =false
                    }else if(PASSOWRD_REG_MIDDLE.test(value)){
                        this.pwWeak=true
                        this.pwThe =true
                    }else if(PASSOWRD_REG_POWER.test(value)){
                        this.pwStrong =true
                    }else{
                        this.pwWeak=true
                        this.pwThe =false
                        this.pwStrong =false
                    }
                    callback();
                }else{
                    this.pwWeak=false
                    this.pwThe =false
                    this.pwStrong =false
                    callback(new Error("请勿输入空格!"));
                }
            }    
            return{
                is_ok:false,
                is_post:false,
                pwWeak:false,
                pwThe:false,
                pwStrong:false,
                data:[],
                addForm:{
                    avatar:"",
                    username:"",
                    name:"",
                    password:"",
                    mobile:"",
                    email:"",
                    jobName:"",
                    status:true,
                    roleIds:[]
                },
                editForm:{
                    id:0,
                    avatar:"",
                    username:"",
                    name:"",
                    password:"",
                    mobile:"",
                    email:"",
                    jobName:"",
                    status:true,
                    roleIds:[]
                },
                selectForm:{
                    name:"",
                    mobile:"",
                    status:"all",
                    jobName:"全部",
                    pageNum:1,
                    pageSize:10
                },
                total:0,
                size:10,
                title:"",
                job_list:[
                    {id:"all",displayName:"全部"}
                ],
                role_list:[],
                status_list:[
                    {id:"all",display_name:"全部"},
                    {id:1,display_name:"启用"},
                    {id:0,display_name:"禁用"}
                ],
                //重置密码
                editPwdRules:{
                    password:[
                        { required: true, message: '请填写新密码', trigger: 'blur' },
                        {validator: passwordStrength, min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                    ],
                },
                //重置密码
                editPwdForm:{
                    id:"",
                    password:""
                },
                addDialog:false,
                tableMaxHeight:0,
                showtable:false,
                current:1,
                rules:{
                    username:[
                        { required: true, message: '请填写登录名', trigger: 'blur' },
                        { validator: stringTrim, trigger: 'blur' },
                        { min: 5, max: 20, message: '登录名长度在 5 到 20 个字符', trigger: 'blur' }
                    ],
                    password:[
                        { required: true, message: '请填写密码', trigger: 'blur' },
                        { validator: passwordStrength, trigger: 'blur' },
                        { min: 6, max: 20, message: '密码长度在6-20位', trigger: 'blur' }
                    ],
                    name:[
                        { required: true, message: '请填写用户姓名', trigger: 'blur' },
                        { validator: stringTrim, trigger: 'blur' },
                        { min: 0, max: 10, message: '姓名不超过10位字符', trigger: 'blur' }
                    ],
                    mobile:[
                        { required: true, message: '请填写手机号', trigger: 'blur' },
                        { pattern:/^1[345789]\d{9}$/, message: '请填写正确的手机号', trigger: 'blur' }
                    ],
                    jobName:[
                        { required: true, message: '请填写职务名称', trigger: 'blur' },
                        { validator: stringTrim, trigger: 'blur' },
                        { min: 0, max: 10, message: '职务名称不超过10个字符', trigger: 'blur' }
                    ],
                    email:[
                        { validator: validEmail, trigger: 'blur' }
                    ],
                    roleIds:[
                        { required: true, message: '请选择身份组', trigger: 'blur' }
                    ]
                },
                is_upload:false,
                editPwdDialog:false,
                add_avatar_review:"",
                edit_avatar_review:"",
                active_user:null,
                editDialog:false,
                active_item:null,
                is_loading:false,
            }
        },
        methods:{
            select(){
                this.selectForm.pageNum = 1;
                this.getData();
            },
            refresh(){
                this.$refs["selectForm"].resetFields();
                this.selectForm = {
                    name:"",
                    mobile:"",
                    status:"all",
                    jobName:"全部",
                    pageNum:1,
                    pageSize:10
                };
                this.getData();
            },
            getData(is_init = false){
                if(!is_init){
                    this.is_post = true;
                    this.is_loading = true;
                }
                request.post("user/list",this.selectForm).then(res=>{
                    this.data = res.data.list;
                    this.total = res.data.total;
                    if(!is_init){
                        this.is_post = false;
                        this.is_loading = false;
                    }else{
                        this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                        this.showtable = true;
                        this.is_ok = true;
                    }
                }).catch(err=>{
                    if(!is_init){
                        this.is_post = false;
                        this.is_loading = false;
                    }else{
                        this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                        this.showtable = true;
                        this.is_ok = true;
                    }
                });
            },
            tableClass({row, rowIndex}) {
                if (rowIndex === 1) {
                    return 'warning-row';
                } else if (rowIndex === 3) {
                    return 'success-row';
                }
                return '';
            },
            parseTime(time){
                return formatTime(time,"{y}-{m}-{d} {h}:{i}:{s}");
            },
            addUser(){
                this.pwWeak=false,
                this.pwThe=false,
                this.pwStrong=false
                this.add_avatar_review = "";
                this.addDialog = !this.addDialog;
            },
            pageChange(page){
                this.selectForm.pageNum = page;
                this.getData();
            },
            random_pwd(t){
                if(t){
                    this.editForm.password = createUniqueString().substr(0,10);
                    this.$refs["editForm"].validateField("password",(valid)=>{});
                }else{
                    this.addForm.password = createUniqueString().substr(0,10);
                    this.$refs["addForm"].validateField("password",(valid)=>{});
                }
            },
            //文件改动
            file_change(e,type){
                let file = e.target.files[0];
                if(type == "edit"){
                    let reader = new FileReader();
                    reader.onload = (event)=>{
                        this.edit_avatar_review = event.target.result;
                    };
                    reader.readAsDataURL(file);
                }else{
                    let reader = new FileReader();
                    reader.onload = (event)=>{
                        this.add_avatar_review = event.target.result;
                    };
                    reader.readAsDataURL(file);
                }
                this.is_upload = true;
                this.$store.dispatch("upload/uploadImg",{file:file}).then(res=>{
                    e.target.value = "";
                    this.is_upload = false;
                    if(type == "add"){
                        this.addForm.avatar = res.url;
                    }else{
                        this.editForm.avatar = res.url;
                    }
                    this.$message.success("上传头像成功!");
                    this.is_upload = false;
                }).catch(err=>{
                    this.is_upload = false;
                    e.target.value = "";
                    this.$message.warning(err.msg);
                });
            },
            //选择图片
            selectImg(type){
                this.$refs[type].click();
            },
            addSubmit(){
                this.$refs["addForm"].validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    request.post("user/create",this.addForm).then(res=>{
                        this.$message.success("添加新用户成功!");
                        this.$refs["addForm"].resetFields();
                        this.addDialog = false;
                        this.data.unshift(res.data);
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            resetForm(form){
                if(form){
                    this.$refs[form].resetFields();
                }else{
                    this.$refs["addForm"].resetFields();
                }
                this.add_avatar_review = "";
            },
            clickDrop(t,item){
                if(t == "resetPwd"){
                    this.pwWeak=false,
                    this.pwThe=false,
                    this.pwStrong=false
                    this.active_user = item;
                    this.editPwdForm.id = item.id;
                    this.editPwdDialog = true;
                    setTimeout(()=>{
                        this.$refs["editPwdForm"].resetFields();
                    },50);
                }else if(t == "edit"){
                    this.active_item = item;
                    this.edit_avatar_review = item.avatar;
                    this.editForm.avatar = item.avatar;
                    this.editForm.email = item.email;
                    this.editForm.name = item.name;
                    this.editForm.username = item.username;
                    this.editForm.jobName = item.jobName;
                    this.editForm.mobile = item.mobile;
                    this.editForm.status = item.status == 1?true:false;
                    this.editForm.id = item.id;
                    let arr = [];
                    for(let item of item.roles){
                        arr.push(item.id);
                    }
                    this.editForm.roleIds = arr;
                    this.editDialog = true;
                    setTimeout(()=>{
                        this.$refs["editForm"].clearValidate();
                    },10);

                }else if(t == "del"){
                    this.del(item);
                }
            },
            editPwdSubmit(){
                this.$refs["editPwdForm"].validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    request.post("user/resetpwd",this.editPwdForm).then(res=>{
                        this.$refs["editPwdForm"].resetFields();
                        this.editPwdForm.password = "";
                        this.editPwdDialog = false;
                        this.$message.success("密码重置成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            //修改提交
            editSubmit(){
                this.$refs["editForm"].validate(valid=>{
                    if(!valid)return false;
                    this.is_post = true;
                    request.post("user/edit",this.editForm).then(res=>{
                        this.editDialog = false;
                        for(let item of this.data){
                            if(item.id == this.editForm.id){
                                for(let k of Object.keys(item)){
                                    if(res.data[k] != "undefined"){
                                        if(k == "status"){
                                            item[k] = res.data[k] == 1?true:false;
                                        }else{
                                            item[k] = res.data[k];
                                        }
                                    }
                                }
                            }
                        }
                        this.$refs["editForm"].resetFields();
                        this.$message.success("用户资料修改成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            //删除用户
            del(item){
                this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.is_post = true;
                    request.post("user/del",{id:item.id}).then(res=>{
                        for(let i = 0;i<this.data.length;i++){
                            if(this.data[i].id == item.id){
                                this.data.splice(i,1);
                            }
                        }
                        this.$message.success("删除用户成功!");
                        this.is_post = false;
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
            },
            changeStatus(item,type){
                this.is_post = true;
                request.post("user/set_status",{id:item.id,status:type}).then(res=>{
                    item.status = type;
                    this.$message.success("修改用户状态成功!");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            },
            getGroup(){
                request.get("permission/group").then(res=>{
                    this.role_list = res.data;
                }).catch(err=>{
                    console.log(err);
                });
            },
            getJobName(){
                request.post("user/job_group").then(res=>{
                    this.job_list = this.job_list.concat(res.data);
                }).catch(err=>{
                    console.log(err);
                });
            }
        },
        created(){

        },
        mounted(){
            this.getGroup();
            this.getJobName();
            this.getData(true);
        }
    }
</script>

<style scoped lang="scss">
   @import '../../styles/passwrodStrength.scss'
</style>
